import React from "react";
//#region Types
import { RatingInfo, CreditRatingProps } from "models/propTypes/commonPropTypes";
import { TranslationKeys } from "translations";
import { CommonConstants } from "utils/constants";
//#endregion
//#region Components
import { Grid, Rating } from "@mui/material";
import { useRatingService, useCustomerService } from "serviceHooks";
//#endregion
import { CSSHelper, LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import ChartNumberSkeleton from "./skeletons/chartNumberSkeleton";

const CreditRating: React.FC<CreditRatingProps> = (props) => {
  const customerService = useCustomerService();
  const ratingService = useRatingService();
  const [ratingData, setRatingData] = React.useState<RatingInfo>();
  const [rating, setRating] = React.useState<number | null>();

  const getRating = () => {
    if (props.orgNr) {
      const orgNr = props.orgNr.includes("-")
        ? props.orgNr
        : UtilsHelper.applyMask(props.orgNr, CommonConstants.OrganizationNumberMask);

      customerService.getCustomerRating(undefined, orgNr).then((rating) => {
        setRating(rating ?? null);
        setRatingData(ratingService.getRatingInfo(props.orgType, rating ?? null));
      });
    } else {
      setRating(null);
      setRatingData(ratingService.getRatingInfo(props.orgType, null));
    }
  };

  React.useEffect(() => {
    getRating();
  }, [props.orgNr]);

  return (
    (ratingData && (
      <Grid
        container
        className={clsx(cssExports.starRatingContainer, CSSHelper.getClassByDisplayType(ratingData.displayType))}
      >
        <Grid container>
          <Rating
            value={ratingData.ratingValue}
            precision={0.5}
            size="large"
            classes={{
              root: cssExports.starRatingRoot,
              iconEmpty: cssExports.starRatingIconEmpty,
            }}
            readOnly
          />
        </Grid>
        <Grid container spacing={3}>
          {rating !== null && (
            <Grid item>
              <Grid className={cssExports.starRatingValue}>{ratingData.ratingText}</Grid>
              <Grid className={cssExports.starRatingTotal}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OutOf, "", { total: "100" })}
              </Grid>
            </Grid>
          )}
          <Grid item xs className={cssExports.starRatingText}>
            {ratingData.displayText}
          </Grid>
        </Grid>
      </Grid>
    )) || <ChartNumberSkeleton />
  );
};

export default CreditRating;
